<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="dropdown ml-3">
            <button
              class="btn green-color dropdown-toggle"
              type="button"
              id="dropdownMenuButtonSearch"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ dropDownProductCategory }}
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButtonSearch"
              style="max-height: 400px; overflow: hidden auto"
            >
              <a
                class="dropdown-item pointer"
                v-for="productCatValue in productCategoriesArray"
                :key="productCatValue.id"
                @click="
                  dropDownProductCategoryClick(
                    productCatValue.nameGe,
                    productCatValue.id
                  )
                "
                >{{ productCatValue.nameGe }}</a
              >
            </div>
          </div>
          <div class="dropdown ml-3">
            <button
              class="btn green-color dropdown-toggle"
              type="button"
              id="dropdownMenuButtonSearchSub"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ dropDownProductSubCategory }}
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButtonSearchSub"
              style="max-height: 400px; overflow: hidden auto"
            >
              <a
                class="dropdown-item pointer"
                v-for="productSubCatValue in productSubCategoriesArray"
                :key="productSubCatValue.id"
                @click="
                  dropDownProductSubCategoryFilterClick(
                    productSubCatValue.nameGe,
                    productSubCatValue.id
                  )
                "
                >{{ productSubCatValue.nameGe }}</a
              >
            </div>
          </div>
          <i
            class="fa fa-search searchBtn ml-3 mt-1"
            title="ძებნა"
            @click="getSubSubCategoriesBySubCategoryId()"
          ></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ქვე ქვე კატეგორიის დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData(), modalPrepare()"
          ></i>
          <!-- <div class="form-group col-8">
          <div class="form-label-group ml-4">
            <input type="text"
                   id="inputSearch"
                   class="form-control"
                   placeholder="ძებნა">
            <label for="inputSearch">ძებნა</label>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1"
             title="ძებნა"></i>
          <i class="fa fa-plus-circle addNewBtn mt-1 ml-4"
             title="ორგანიზაციის დამატება"
             data-toggle="modal"
             data-target="#exampleModalLong"
             @click="clearData()"></i>
          </div>-->
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის ქვე ქვე კატეგორიის დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="dropdown ml-3">
                  <button
                    class="btn green-color dropdown-toggle"
                    type="button"
                    id="dropdownMenuButtonSearch"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ dropDownProductCategory }}
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButtonSearch"
                    style="max-height: 400px; overflow: hidden auto"
                  >
                    <a
                      class="dropdown-item pointer"
                      v-for="productCatValue in productCategoriesArray"
                      :key="productCatValue.id"
                      @click="
                        dropDownProductCategoryClick(
                          productCatValue.nameGe,
                          productCatValue.id
                        )
                      "
                      >{{ productCatValue.nameGe }}</a
                    >
                  </div>
                </div>
                <div class="dropdown ml-3 mt-3">
                  <button
                    class="btn green-color dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ dropDownProductSubCategory }}
                  </button>
                  <div
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 400px; overflow: hidden auto"
                  >
                    <a
                      class="dropdown-item pointer"
                      v-for="productSubCatValue in productSubCategoriesArray"
                      :key="productSubCatValue.id"
                      v-on:focus="$v.productSubCategory.$touch"
                      @click="
                        dropDownProductSubCategoryClick(
                          productSubCatValue.nameGe,
                          productSubCatValue.id
                        )
                      "
                      v-bind:class="{
                        'error-border': $v.productSubCategory.nameGe.$error,
                        valid:
                          $v.productSubCategory.nameGe.$dirty &&
                          !$v.productSubCategory.nameGe.$invalid,
                      }"
                      >{{ productSubCatValue.nameGe }}</a
                    >
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameGeAdd"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="productSubSubCategory.nameGe"
                      v-on:input="$v.productSubSubCategory.$touch"
                      v-bind:class="{
                        'error-border': $v.productSubSubCategory.nameGe.$error,
                        valid:
                          $v.productSubSubCategory.nameGe.$dirty &&
                          !$v.productSubSubCategory.nameGe.$invalid,
                      }"
                    />
                    <label for="nameGeAdd">სახელი ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameEnAdd"
                      class="form-control"
                      placeholder="English Name"
                      autofocus="autofocus"
                      v-model="productSubSubCategory.nameEn"
                      v-on:input="$v.productSubSubCategory.$touch"
                      v-bind:class="{
                        'error-border': $v.productSubSubCategory.nameEn.$error,
                        valid:
                          $v.productSubSubCategory.nameEn.$dirty &&
                          !$v.productSubSubCategory.nameEn.$invalid,
                      }"
                    />
                    <label for="nameEnAdd">English Name</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameRuAdd"
                      class="form-control"
                      placeholder="имя на русском"
                      autofocus="autofocus"
                      v-model="productSubSubCategory.nameRu"
                      v-on:input="$v.productSubSubCategory.$touch"
                      v-bind:class="{
                        'error-border': $v.productSubSubCategory.nameRu.$error,
                        valid:
                          $v.productSubSubCategory.nameRu.$dirty &&
                          !$v.productSubSubCategory.nameRu.$invalid,
                      }"
                    />
                    <label for="nameRuAdd">имя на русском</label>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              v-if="!isActive"
              type="button"
              class="btn btn-success"
              :disabled="
                !$v.productSubSubCategory.$dirty ||
                $v.productSubSubCategory.$error
              "
              @click="
                $v.productSubSubCategory.$touch(), addProductSubSubCategory()
              "
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActive"
              type="button"
              class="btn btn-success"
              :disabled="
                !$v.productSubSubCategory.$dirty ||
                $v.productSubSubCategory.$error
              "
              @click="
                $v.productSubSubCategory.$touch(), editProductSubSubCategory()
              "
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <!--<th class="numeric">პროდუქტის კატეგორია</th>-->
            <th class="numeric">სახელი ქართულად</th>
            <th class="numeric">English Name</th>
            <th class="numeric">имя на русском</th>
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueProductSubSubCategory in productSubSubCategoriesArray"
            :key="valueProductSubSubCategory.id"
          >
            <!--<td data-title="სახელი ქართულად" class="numeric">
              {{ getProductSubCategoryNameByID(valueProductSubSubCategory.id) }}
            </td>
            -->
            <td data-title="სახელი ქართულად" class="numeric">
              {{ valueProductSubSubCategory.nameGe }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ valueProductSubSubCategory.nameEn }}
            </td>
            <td data-title="имя на русском" class="numeric">
              {{ valueProductSubSubCategory.nameRu }}
            </td>
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  @click="
                    editFillInputs(valueProductSubSubCategory),
                      modalPrepareEdit()
                  "
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  @click="getDeleteId(valueProductSubSubCategory.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5
              class="modal-title text-white"
              id="exampleModalLongTitle"
            >პროდუქტის ქვე ქვე კატეგორიის რედაქტირება</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <div class="dropdown ml-3 mt-3">
                  <button
                    class="btn green-color dropdown-toggle"
                    type="button"
                    id="dropdownMenuButtonEdit"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >{{dropDownProductSubCategory}}</button>
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButtonEdit">
                    <a
                      class="dropdown-item pointer"
                      v-for="productSubCatValue in productSubCategoriesArray"
                      :key="productSubCatValue.id"
                      v-on:focus="$v.productSubCategory.$touch"
                      @click="dropDownProductSubCategoryClick(productSubCatValue.nameGe, productSubCatValue.subCategoryId)"
                      v-bind:class="{'error-border': $v.productSubCategory.nameGe.$error, valid: $v.productSubCategory.nameGe.$dirty && !$v.productSubCategory.nameGe.$invalid}"
                    >{{productSubCatValue.nameGe}}</a>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameGeEdit"
                      class="form-control"
                      placeholder="სახელი ქართულად"
                      autofocus="autofocus"
                      v-model="productSubSubCategory.nameGe"
                      v-on:input="$v.productSubSubCategory.$touch"
                      v-bind:class="{'error-border': $v.productSubSubCategory.nameGe.$error, valid: $v.productSubSubCategory.nameGe.$dirty && !$v.productSubSubCategory.nameGe.$invalid}"
                    >
                    <label for="nameGeEdit">სახელი ქართულად</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameEnEdit"
                      class="form-control"
                      placeholder="English Name"
                      autofocus="autofocus"
                      v-model="productSubSubCategory.nameEn"
                      v-on:input="$v.productSubSubCategory.$touch"
                      v-bind:class="{'error-border': $v.productSubSubCategory.nameEn.$error, valid: $v.productSubSubCategory.nameEn.$dirty && !$v.productSubSubCategory.nameEn.$invalid}"
                    >
                    <label for="nameEnEdit">English Name</label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="nameRuEdit"
                      class="form-control"
                      placeholder="имя на русском"
                      autofocus="autofocus"
                      v-model="productSubSubCategory.nameRu"
                      v-on:input="$v.productSubSubCategory.$touch"
                      v-bind:class="{'error-border': $v.productSubSubCategory.nameRu.$error, valid: $v.productSubSubCategory.nameRu.$dirty && !$v.productSubSubCategory.nameRu.$invalid}"
                    >
                    <label for="nameRuEdit">имя на русском</label>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">დახურვა</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.productSubSubCategory.$dirty || $v.productSubSubCategory.$error"
              @click="$v.productSubSubCategory.$touch(), editProductSubSubCategory()"
              data-dismiss="modal"
            >რედაქტირება</button>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              პროდუქტის წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteProductSubSubCategory()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import { required } from "vuelidate/lib/validators";

export default {
  name: "products",
  data() {
    return {
      showModal: false,
      dropDownCategoryName: "აირჩიეთ კატეგორია",
      productSubSubCategory: {
        id: null,
        subCategory1Id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      productSubCategory: {
        subCategoryId: null,
        categoryId: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      productCategory: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
      },
      lastID: 4,
      isActive: false,
      dropDownProductCategory: "პროდუქტის კატეგორიები",
      dropDownProductSubCategory: "პროდუქტის ქვე-კატეგორიები",
      productCategoriesArray: [],
      productSubCategoriesArray: [],
      productSubSubCategoriesArray: [],
    };
  },
  validations: {
    productSubSubCategory: {
      nameGe: {
        required,
      },
      nameEn: {
        required,
      },
      nameRu: {
        required,
      },
    },
    productSubCategory: {
      nameGe: {
        required,
      },
    },
  },
  async created() {
    let productCategoryResult = await this.$http.getProductCategory();
    this.productCategoriesArray = productCategoryResult.data.res;
  },
  methods: {
    async addProductSubSubCategory() {
      try {
        console.log(this.productSubSubCategory);
        let productSubSubCategoryObjectAdd = {
          subCategory1Id: this.productSubSubCategory.subCategory1Id,
          nameGe: this.productSubSubCategory.nameGe,
          nameEn: this.productSubSubCategory.nameEn,
          nameRu: this.productSubSubCategory.nameRu,
        };

        let productSubSubCategoryAddResult =
          await this.$http.postProductSubSubCategory(
            productSubSubCategoryObjectAdd
          );

        if (productSubSubCategoryAddResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ქვეკატეგორია წარმატებით დაემატა");
          let productSubSubCategoryResult =
            await this.$http.getByIDProductSubSubCategory(
              productSubSubCategoryObjectAdd.subCategory1Id
            );
          this.productSubSubCategoriesArray =
            productSubSubCategoryResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ქვეკატეგორიის დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editProductSubSubCategory() {
      try {
        let productSubSubCategoryEditResult =
          await this.$http.putProductSubSubCategory(this.productSubSubCategory);

        if (productSubSubCategoryEditResult.data.resultCode === "200") {
          bus.$emit(
            "success",
            "პროდუქტის ქვეკატეგორია წარმატებით დარედაქტირდა"
          );
          let productSubSubCategoryResult =
            await this.$http.getByIDProductSubSubCategory(
              this.productSubSubCategory.subCategory1Id
            );
          this.productSubSubCategoriesArray =
            productSubSubCategoryResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ქვეკატეგორიის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async deleteProductSubSubCategory() {
      try {
        let productSubSubCategoryDeleteResult =
          await this.$http.deleteProductSubSubCategory(
            this.productSubSubCategory.id
          );

        if (productSubSubCategoryDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "პროდუქტის ქვეკატეგორია წარმატებით წაიშალა");
          let productSubSubCategoryResult =
            await this.$http.getByIDProductSubSubCategory(
              this.productSubSubCategory.subCategory1Id
            );
          this.productSubSubCategoriesArray =
            productSubSubCategoryResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "პროდუქტის ქვეკატეგორიის წაშლის დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit(
          "warning",
          "პროდუქტის ქვეკატეგორიის წაშლის დროს მოხდა შეცდომა"
        );
        //bus.$emit("error", error);
      }
    },
    editFillInputs(row) {
      //console.log(row, this.productSubSubCategoriesArray);
      //let index = this.productSubSubCategoriesArray.findIndex(
      //(d) => d.id === row.id
      //);

      //this.productSubSubCategoriesArray =
      //this.productSubSubCategory[index].nameGe;
      this.productSubSubCategory = Object.assign({}, row);
    },
    getDeleteId(id) {
      this.productSubSubCategory.id = id;
    },
    dropDownProductCategoryClick(productCategoryName, categoryId) {
      //console.log("111", productCategoryName, categoryId);
      this.dropDownProductCategory = productCategoryName;
      this.productCategory.nameGe = productCategoryName;
      this.productSubCategory.categoryId = categoryId;
      this.getSubCategoriesByCategoryId();
      this.dropDownProductSubCategoryClick("პროდუქტის ქვე-კატეგორიები", 0);
      this.productSubSubCategoriesArray = null;
    },
    dropDownProductSubCategoryClick(productSubCategoryName, subCategoryId) {
      //console.log("222", productSubCategoryName, subCategoryId);
      this.dropDownProductSubCategory = productSubCategoryName;
      this.productSubCategory.nameGe = productSubCategoryName;
      this.productSubSubCategory.subCategory1Id = subCategoryId;
    },
    async dropDownProductSubCategoryFilterClick(
      productSubCategoryName,
      subCategoryId
    ) {
      this.dropDownProductSubCategory = productSubCategoryName;
      this.productSubCategory.nameGe = productSubCategoryName;
      this.productSubSubCategory.subCategory1Id = subCategoryId;

      let productSubSubCategoryResult =
        await this.$http.getByIDProductSubSubCategory(subCategoryId);
      this.productSubSubCategoriesArray = productSubSubCategoryResult.data.res;
    },
    getProductSubCategoryNameByID(id) {
      let index = this.productSubSubCategoriesArray.findIndex(
        (d) => d.id === id
      );
      return this.productSubSubCategoriesArray[index].nameGe;
    },
    async getSubCategoriesByCategoryId() {
      if (this.productSubCategory.categoryId !== null) {
        let productSubCategoryResult =
          await this.$http.getByIDProductSubCategory(
            this.productSubCategory.categoryId
          );
        this.productSubCategoriesArray = productSubCategoryResult.data.res;
      }
    },
    async getSubSubCategoriesBySubCategoryId() {
      if (this.productSubSubCategory.subCategory1Id !== null) {
        let productSubSubCategoryResult =
          await this.$http.getByIDProductSubSubCategory(
            this.productSubSubCategory.subCategory1Id
          );
        this.productSubSubCategoriesArray =
          productSubSubCategoryResult.data.res;
      }
    },
    modalPrepareEdit() {
      this.isActive = true;
    },
    modalPrepare() {
      this.isActive = false;
    },
    clearData() {
      this.productSubSubCategory.id = null;
      this.productSubSubCategory.subCategory1Id = null;
      this.productSubSubCategory.nameGe = "";
      this.productSubSubCategory.nameEn = "";
      this.productSubSubCategory.nameRu = "";
      this.productSubCategory.id = null;
      this.productSubCategory.categoryId = null;
      this.productSubCategory.nameGe = "";
      this.productSubCategory.nameEn = "";
      this.productSubCategory.nameRu = "";
      this.productCategory.id = null;
      this.productCategory.nameGe = "";
      this.dropDownProductCategory = "პროდუქტის კატეგორიები";
      this.dropDownProductSubCategory = "პროდუქტის ქვე-კატეგორიები";
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

// .error-border {
//   border-color: #ffb3b3;
//   box-shadow: none;
// }
// .editBtn {
//   margin-left: 10px;
//   font-size: 30px;
//   cursor: pointer;
//   color: #52af8e;
// }
// .deleteBtn {
//   font-size: 30px;
//   cursor: pointer;
//   color: #d43f3a;
//   margin-left: 10px;
// }

// .searchBtn {
//   font-size: 40px;
//   margin-top: -5px;
//   cursor: pointer;
//   color: #489d7f;
// }

// .addNewBtn {
//   font-size: 44px;
//   margin-left: 15px;
//   cursor: pointer;
//   color: #52af8e;
//   margin-top: -5px;
// }

// @media only screen and (min-width: 1450px) {
//   #no-more-tables table {
//     border-style: none;
//   }
//   #no-more-tables th {
//     padding: 12px;
//     font-weight: bold;
//     border-style: none;
//     border-bottom: solid #212529 4px;
//   }
//   #no-more-tables td {
//     padding: 10px;
//     font-family: "BPGNinoMtavruli";
//     border-style: none;
//     border-bottom: solid #212529 2px;
//   }
// }

// @media only screen and (max-width: 1450px) {
//   .deleteBtn {
//     margin-left: 5px;
//   }
//   #no-more-tables table,
//   #no-more-tables thead,
//   #no-more-tables tbody,
//   #no-more-tables th,
//   #no-more-tables td,
//   #no-more-tables tr {
//     display: block;
//     border-style: none;
//   }
//   #no-more-tables thead tr {
//     position: absolute;
//     top: -9999px;
//     left: -9999px;
//   }
//   #no-more-tables tr {
//     border-bottom: 4px solid #212529;
//   }
//   #no-more-tables td {
//     border-bottom: 1px solid #eee;
//     position: relative;
//     padding-left: 50%;
//     white-space: normal;
//     text-align: left;
//   }
//   #no-more-tables td:before {
//     position: absolute;
//     top: 6px;
//     left: 6px;
//     width: 45%;
//     padding-right: 10px;
//     white-space: nowrap;
//     text-align: left;
//     font-weight: bold;
//   }
//   #no-more-tables td:before {
//     content: attr(data-title);
//   }
// }
// @media only screen and (max-width: 600px) {
//   .container {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
//   #no-more-tables table {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/view/ProductSubSubCategory.vue